import { PipeTransform, Pipe } from '@angular/core';
import { environment } from '@environments/environment';

@Pipe({ name: 'isoCountry' })
export class IsoCountriesPipe implements PipeTransform {
  transform(value, args?: string[]): any {
    let rval;
    if (value) {
      if (value === 'i0') {
        rval = 'un';
      } else if (value === 'wa') {
        rval = 'gb-wls';
      } else if (value === 'sw') {
        rval = 'se';
      } else if (value === 'dn') {
        rval = 'dk';
      } else if (value === 'en') {
        rval = 'gb-eng';
      } else if (value === 'sf') {
        rval = 'gb-sct';
      } else {
        return value;
      }

      return rval;
    }
  }
}
